import { render, staticRenderFns } from "./mapModel.vue?vue&type=template&id=6671a2d6"
import script from "./mapModel.vue?vue&type=script&lang=js"
export * from "./mapModel.vue?vue&type=script&lang=js"
import style0 from "./mapModel.vue?vue&type=style&index=0&id=6671a2d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports